module.exports = __webpack_public_path__ + "static/media/instaPage.1f7835a2.svg";